import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _isBoolean from "lodash/isBoolean";
/* eslint-disable consistent-return */

import React from 'react';
import { Box } from "../Box";
import styled, { css } from 'styled-components';
import { theme, whenFocused, whenHovered } from "../../theme";
import { getBackgroundColor } from "../../theme/color-tokens";
import { whenPressed } from "../../theme/utils";
var interactive = theme.colors.background.interactive;
export var Interactive = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$transitionDurati = _ref.transitionDuration,
      transitionDuration = _ref$transitionDurati === void 0 ? 100 : _ref$transitionDurati,
      other = _objectWithoutProperties(_ref, ["transitionDuration"]);

  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    transitionDuration: transitionDuration
  }, other, {
    ref: forwardedRef
  }));
});

var duration = function duration(p) {
  return p.transitionDuration;
};

var baseStyles = css(["outline:none;cursor:", ";background-color:", ";transition:background ", "ms linear,box-shadow ", "ms linear;"], function (p) {
  return p.pointer && 'pointer';
}, function (p) {
  return getBackgroundColor(p.background);
}, duration, duration);

function withOptionalSelectorInteractive(prop, selector, styles) {
  return function (p) {
    if (!_isBoolean(p[prop]) && !p.isSelected && !p.isActivated) {
      return css(["", "{", "}"], selector, styles);
    }

    if (p[prop]) {
      return styles;
    }
  };
}

function withInteractive(prop, styles) {
  return function (p) {
    return p[prop] && styles;
  };
}

var hoverStyles = css(["background-color:", ";"], interactive.hover);

function getShadow(color) {
  return "0px 0px 0px 1px ".concat(theme.colors.palette.grey10, ",\n  0px 0px 0px 2px ").concat(color);
}

var focusStyles = css(["box-shadow:inset 0px 0px 0px 1px ", ";"], theme.colors.border.interactive.focused);
var pressedStyles = css(["background-color:", ";"], interactive.pressed);
var activatedStyles = css(["background-color:", ";box-shadow:", ";"], interactive.activated, getShadow(theme.colors.border.interactive.activated));
var selectedStyles = css(["background-color:", ";box-shadow:", ";"], interactive.selected, getShadow(theme.colors.border.interactive.selected));
var disabledStyles = css(["background-color:", ";pointer-events:none;"], interactive.disabled);
var StyledBox = styled(Box).withConfig({
  displayName: "Interactive__StyledBox",
  componentId: "vapor__sc-1le88q4-0"
})(["", ";", ";", ";", " ", ";", ";", ";"], baseStyles, withOptionalSelectorInteractive('isHovered', whenHovered, hoverStyles), withOptionalSelectorInteractive('isFocused', whenFocused, focusStyles), withOptionalSelectorInteractive('isPressed', whenPressed, pressedStyles), withInteractive('isActivated', activatedStyles), withInteractive('isSelected', selectedStyles), withInteractive('disabled', disabledStyles));